/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

$(window).on("load", function () {
  var ms_domain = "https://sync.fusedship.com",
    rateRequest = false;

  "object" == typeof Countries &&
    (Countries.updateProvinceLabel = function (e, t) {
      if ("string" == typeof e && Countries[e] && Countries[e].provinces) {
        if (
          "object" != typeof t &&
          ((t = document.getElementById("address_province_label")), null === t)
        )
          return;
        t.innerHTML = Countries[e].label;
        var r = jQuery(t).parent();
        r.find("select");
        r.find(".custom-style-select-box-inner").html(
          Countries[e].provinces[0]
        );
      }
    }),
    "undefined" == typeof Shopify.Cart && (Shopify.Cart = {}),
    (Shopify.Cart.ShippingCalculator = (function () {
      var cartData = [],
        _config = {
          submitButton: "Calculate shipping",
          submitButtonDisabled: "Calculating...",
          templateId: "shipping-calculator-response-template",
          wrapperId: "wrapper-response",
          customerIsLoggedIn: !1,
          moneyFormat: "${{amount}}",
        },
        _render = function (e) {
          var t = jQuery("#" + _config.templateId),
            r = jQuery("#" + _config.wrapperId);
          if (t.length && r.length) {
            _.templateSettings = {
              evaluate: /<%([\s\S]+?)%>/g,
              interpolate: /<%=([\s\S]+?)%>/g,
              escape: /<%-([\s\S]+?)%>/g,
            };
            var n = _.template(jQuery.trim(t.text())),
              a = n(e);
            if (
              (jQuery(a).appendTo(r),
              "undefined" != typeof Currency &&
                "function" == typeof Currency.convertAll)
            ) {
              var i = "";
              jQuery("[name=currencies]").size()
                ? (i = jQuery("[name=currencies]").val())
                : jQuery("#currencies span.selected").size() &&
                  (i = jQuery("#currencies span.selected").attr(
                    "data-currency"
                  )),
                "" !== i &&
                  Currency.convertAll(
                    shopCurrency,
                    i,
                    "#wrapper-response span.money, #estimated-shipping span.money"
                  );
            }
          }
        },
        _enableButtons = function () {
          jQuery("#get-rates")
            .removeAttr("disabled")
            .removeClass("disabled")
            .val(_config.submitButton);
        },
        _disableButtons = function () {
          jQuery("#get-rates")
            .val(_config.submitButtonDisabled)
            .attr("disabled", "disabled")
            .addClass("disabled");
        },
        _getCartShippingRatesForDestination = function (e) {
          var firstForm = $('form[action="/cart/add"]').eq(0),
            productId = firstForm.find('input[name="id"]').val(),
            selectedProductId_1 = firstForm
              .find('select[name="id"]')
              .find("option:eq(0)")
              .val(), // this is to get the product in hidden form without user click
            selectedProductId_2 = firstForm
              .find('select[name="id"]')
              .find("option:selected")
              .val(),
            selectedProductId = "";

          if (productId > 0) {
            selectedProductId = productId;
          } else if (selectedProductId_1 > 0) {
            selectedProductId = selectedProductId_1;
          } else if (selectedProductId_2 > 0) {
            selectedProductId = selectedProductId_2;
          }

          // first we need to fetch all the products in cart
          // then store them in a variable
          // then we empty the cart
          // and add only the product that we want to get the shipping rates
          // after getting the shipping rates we delete that added product
          // finally we add the products back to the cart

          rateRequest = true;
          var addData = {
            id: selectedProductId,
            quantity: $('input[name="quantity"]').val(),
          };

          fetch("/cart.js", {
            method: "GET",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              var cartItems = json.items;
              cartData = [];
              $.each(cartItems, function (index, item) {
                cartData.push({
                  id: item.id,
                  quantity: item.quantity,
                });
              });

              fetch("/cart/clear.js", {
                method: "POST",
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then(function (response) {
                  return response.json();
                })
                .then(function (json) {
                  fetch("/cart/add.js", {
                    body: JSON.stringify(addData),
                    credentials: "same-origin",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                    },
                    method: "POST",
                  })
                    .then(function (response) {
                      return response.json();
                    })
                    .then(function (json) {
                      if (json.status) {
                        rateRequest = false;
                        _enableButtons();

                        $(".msc-w-response").html(
                          '<ul id="shipping-rates" class="msc-rates-list"><li><strong>ERROR:</strong> ' +
                            json.description +
                            "</li></ul>"
                        );
                        $(".msc-w-response").show();
                        return;
                      }
                      $.ajax({
                        type: "GET",
                        url: "/cart/shipping_rates.json",
                        data: jQuery.param({
                          shipping_address: e,
                        }),
                        success: function (r, n, a) {
                          200 === a.status
                            ? _onCartShippingRatesUpdate(r.shipping_rates, e)
                            : setTimeout(t, 500);

                          rateRequest = false;
                          _updateProductQuantity();
                        },
                        error: _onError,
                        dataType: "json",
                      });
                    })
                    .catch(function (err) {
                      /* uh oh, we have error. */
                      rateRequest = false;
                      console.error(err);
                    });
                })
                .catch(function (err) {
                  rateRequest = false;
                  console.error(err);
                });
            });
        },
        _fullMessagesFromErrors = function (e) {
          var t = [];
          return (
            jQuery.each(e, function (e, r) {
              jQuery.each(r, function (r, n) {
                t.push(e + " " + n);
              });
            }),
            t
          );
        },
        _onError = function (XMLHttpRequest, textStatus) {
          jQuery("#estimated-shipping").hide(),
            jQuery("#estimated-shipping em").empty(),
            _enableButtons();

          var feedback = "",
            data = eval("(" + XMLHttpRequest.responseText + ")");
          (feedback = data.message
            ? data.message + "(" + data.status + "): " + data.description
            : "Error : " + _fullMessagesFromErrors(data).join("; ") + "."),
            "Error : country is not supported." === feedback &&
              (feedback = "We do not ship to this destination."),
            _render({ rates: [], errorFeedback: feedback, success: !1 }),
            jQuery("#" + _config.wrapperId).show();
          _updateProductQuantity();
        },
        _updateProductQuantity = function () {
          // clear the cart
          fetch("/cart/clear.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              if (cartData.length == 0) {
                return;
              }
              let formData = {
                items: cartData,
              };
              // add the products back to the cart
              fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(formData),
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With":
                    "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                },
              })
                .then(function (response) {
                  return response.json();
                })
                .then(function (json) {
                  console.log("Product added to cart");
                })
                .catch(function (err) {
                  console.error(err);
                });
            })
            .catch(function (err) {
              console.error(err);
            });
        },
        _onCartShippingRatesUpdate = function (e, t) {
          _enableButtons();
          var r = "";
          if (
            (t.zip && (r += t.zip + ", "),
            t.province && (r += t.province + ", "),
            (r += t.country),
            e.length)
          ) {
            "0.00" == e[0].price
              ? jQuery("#estimated-shipping em").html("FREE")
              : jQuery("#estimated-shipping em").html(e[0].price);
            for (var n = 0; n < e.length; n++) {
              // e[n].price = _formatRate(e[n].price);
              e[n].price = "$" + e[n].price;
            }
          }
          _render({ rates: e, address: r, success: !0 }),
            jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn();
        },
        _formatRate = function (e) {
          function t(e, t) {
            return "undefined" == typeof e ? t : e;
          }
          function r(e, r, n, a) {
            if (
              ((r = t(r, 2)),
              (n = t(n, ",")),
              (a = t(a, ".")),
              isNaN(e) || null == e)
            )
              return 0;
            e = (e / 100).toFixed(r);
            var i = e.split("."),
              o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
              s = i[1] ? a + i[1] : "";
            return o + s;
          }
          // if ("function" == typeof Shopify.formatMoney)
          //   return Shopify.formatMoney(e, _config.moneyFormat);
          "string" == typeof e && (e = e.replace(".", ""));
          var n = "",
            a = /\{\{\s*(\w+)\s*\}\}/,
            i = _config.moneyFormat;
          switch (i.match(a)[1]) {
            case "amount":
              n = r(e, 2);
              break;
            case "amount_no_decimals":
              n = r(e, 0);
              break;
            case "amount_with_comma_separator":
              n = r(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n = r(e, 0, ".", ",");
          }
          return i.replace(a, n);
        };
      return (
        (_init = function () {
          var e = jQuery("#address_country"),
            t = jQuery("#address_province_label").get(0);
          "undefined" != typeof Countries &&
            (Countries.updateProvinceLabel(e.val(), t),
            e.change(function () {
              Countries.updateProvinceLabel(e.val(), t);
            })),
            (stateOptions = jQuery("#address_province option")),
            (address_zip = jQuery("#address_zip").val() || "");

          // LOCATION REQUEST
          $("#get-rates").attr("disabled", "disabled");
          var oldVal = "",
            timeoutId = "";

          if (
            e.find("option:selected").val() == "---" ||
            e.find("option:selected").val() == ""
          ) {
            e.find("option:contains(Australia)").attr("selected", true);
          }

          jQuery("#address_zip").on("input", function (e) {
            if ($("#zip-list").children("a").length) {
              $("#zip-list").attr("style", "");
            } else {
              $("#zip-list").html("");
              $("#zip-list").append('<a href="">LOADING...</a>');
            }

            var currVal = this.value;
            clearTimeout(timeoutId);
            // validate if input is number and exclude those alt, tab etc press
            if (e.which != 8 && isNaN(String.fromCharCode(e.which))) {
              e.preventDefault(); //stop character from entering input
            }

            // check if the current input is already 4 characters and not the same as the old value
            if (
              jQuery.isNumeric(currVal) &&
              currVal.length == 4 &&
              oldVal != currVal
            ) {
              // set timeout to 1 second before sending request
              // because customer might be deciding the last digit
              // and to avoid sending the requeest over and over
              timeoutId = setTimeout(function () {
                // set the default value of select dropdown
                $("#zip-list").html("");
                $("#zip-list").append('<a href="">LOADING...</a>');

                $.ajax({
                  type: "GET",
                  url: ms_domain + "/machship-api/location-request",
                  data: jQuery.param({
                    domain: Shopify.shop,
                    postcode: currVal,
                    cdn: "https://" + Shopify.cdnHost,
                    platform: "Shopify",
                  }),
                  success: function (response) {
                    if (response.data && response.status) {
                      // update the old value to the current value
                      oldVal = currVal;
                      $("#zip-list").html("");
                      $("#zip-list").append('<a href="">&nbsp;</a>');
                      // map the response data to the select dropdown
                      // sort suburbs alphabetically by description before appending
                      response.data.sort(function (a, b) {
                        return a.description.localeCompare(b.description);
                      });
                      $.each(response.data, function (index, value) {
                        $("#zip-list").append(
                          '<a href="" data-state="' +
                            value.state.code +
                            '" data-suburb="' +
                            value.suburb +
                            '">' +
                            value.description +
                            "</a>"
                        );
                      });
                    } else {
                      // if there is no data, show the error message
                      $("#zip-list").html("");
                      $("#zip-list").append(
                        "<a>" + JSON.stringify(response.data) + "</a>"
                      );
                    }
                  },
                  error: function (err) {
                    // update the old value to the current value
                    oldVal = currVal;
                    // since it's error show the error message
                    $("#zip-list").html("");
                    $("#zip-list").append("<a>" + JSON.stringify(err) + "</a>");
                    console.error("error", err);
                  },
                });
              }, 1000);
            }
          });

          jQuery("#address_zip").on("click", function () {
            if ($("#zip-list").children("a").length) {
              $("#zip-list").attr("style", "");
            }
          });

          jQuery("#zip-list").on("blur", function () {
            $("#zip-list").attr("style", "display:none;");
          });

          jQuery("#zip-list").on("click", "a", function (e) {
            e.preventDefault();
            $("#zip-list").attr("style", "display:none;");
            if ($(this).data("suburb")) {
              $("#address_city").val($(this).data("suburb"));
              $("#hidden_state").val($(this).data("state"));
              $("#get-rates").removeAttr("disabled");

              // Update the suburb/state display element
              $("#suburb-state-display")
                .text($(this).data("suburb") + ", " + $(this).data("state"))
                .show();
            }
          });

          jQuery("#get-rates").click(function () {
            var e = {};
            (e.zip = jQuery("#address_zip").val() || ""),
              (e.country = jQuery("#address_country").val() || ""),
              (e.province = jQuery("#hidden_state").val() || ""),
              (e.city = jQuery("#address_city").val() || "");
            if (
              e.zip.length <= 0 ||
              e.country.length <= 0 ||
              e.city.length <= 0
            ) {
              jQuery("#" + _config.wrapperId)
                .html(
                  "<center><span style='color: red;'>Please fill up all the fields.</span></center>"
                )
                .show();
              return;
            }
            _disableButtons(),
              jQuery("#" + _config.wrapperId)
                .empty()
                .hide();

            if (!rateRequest) {
              _getCartShippingRatesForDestination(e);
            }
          });
        }),
        {
          show: function (e) {
            (e = e || {}),
              jQuery.extend(_config, e),
              jQuery(function () {
                _init();
              });
          },
          getConfig: function () {
            return _config;
          },
          formatRate: function (e) {
            return _formatRate(e);
          },
        }
      );
    })());
});
